module.exports = __webpack_public_path__ + "img/inner2blur.ee641a0c.jpg";